import { Component, Event, EventEmitter, h, Host, Prop, State } from "@stencil/core";
import copyToClipboard from "../../utils/copyToClipboard";

@Component({
    tag: "ux-copy-to-clipboard",
    styleUrl: "copy-to-clipboard.scss",
    shadow: true
})
export class CopyToClipboard {
    private baseClass = "ux-copy-to-clipboard";

    /** Link which can be copied  */
    @Prop({ reflect: true }) readonly textToCopy: string;

    /** Default icon */
    @Prop() readonly clickToCopyIcon: string = "documents";

    /** Icon shown after copy link was clicked */
    @Prop() readonly clickToCopyIconSuccessful: string = "checkmark";

    /** Default message which indicates link is copyable */
    @Prop() readonly clickToCopyMessage: string;

    /** Message which gets shown after clicking the copy link */
    @Prop() readonly clickToCopyMessageSuccessful: string;

    /** The label to be added to the button for accessibility purposes */
    @Prop() readonly copyButtonLabel: string = "Copy the following text to clipboard:";

    /** Setting wether link to be copied is hidden */
    @Prop() readonly hideTextToCopy?: boolean = false;

    @State() wasSuccessful = false;

    /** event emitted when the copy to clipboard function has been executed */
    @Event({
        eventName: "uxCopyToClipboard",
        composed: true,
        cancelable: true,
        bubbles: true
    })
    copyToClipboard: EventEmitter<{
        success: boolean;
        copiedText: null | string;
    }>;

    private clickHandler = (stringToCopy: string) => {
        copyToClipboard(stringToCopy)
            .then((response: boolean) => {
                this.wasSuccessful = response;
                this.copyToClipboard.emit({
                    success: true,
                    copiedText: stringToCopy
                });
            })
            .catch(function (err) {
                /* eslint-disable-next-line no-console */
                console.log("Could not copy link:", err);
                this.copyToClipboard.emit({ success: false, copiedText: null });
            });
        setTimeout(() => {
            this.wasSuccessful = false;
        }, 2000);
    };

    render() {
        return (
            <Host class={this.baseClass}>
                {typeof this.textToCopy === "string" && (
                    <button
                        onClick={() => this.clickHandler(this.textToCopy)}
                        type="button"
                        aria-label={`${this.copyButtonLabel} "${this.textToCopy}"`}
                        class={`${this.baseClass}__button`}
                    >
                        {!this.hideTextToCopy && <span class={`${this.baseClass}__text-to-copy`}>{this.textToCopy}</span>}
                        <span class={`${this.baseClass}__copy-area`}>
                            {(this.clickToCopyMessage || this.clickToCopyMessageSuccessful) && (
                                <span class={`${this.baseClass}__message`}>
                                    {this.wasSuccessful ? this.clickToCopyMessageSuccessful : this.clickToCopyMessage}
                                </span>
                            )}
                            <ux-icon
                                name={this.wasSuccessful ? this.clickToCopyIconSuccessful : this.clickToCopyIcon}
                                weight="normal"
                            ></ux-icon>
                        </span>
                    </button>
                )}
            </Host>
        );
    }
}
